import useAudioPlayerControls from './useAudioPlayerControls';

export default useAudioPlayerControls;
